'use client'

import { useQuery } from '@tanstack/react-query'

interface UseOrdersParams {
  from?: string
  to?: string
  search?: string
}

export const useOrders = ({ from, to, search }: UseOrdersParams = {}) => {
  return useQuery({
    queryKey: ['orders', { from, to, search }],
    queryFn: async () => {
      const params = new URLSearchParams()
      if (from) params.append('from', from)
      if (to) params.append('to', to)
      if (search) params.append('search', search)

      const queryString = params.toString()
      const url = `/api/order/search${queryString ? `?${queryString}` : ''}`

      const response = await fetch(url)
      if (!response.ok) {
        throw new Error('Failed to fetch orders')
      }
      const data = await response.json()
      return Array.isArray(data) ? data : []
    },
    staleTime: 0,
    refetchOnWindowFocus: true,
  })
}
